import moment from "moment";

/** * Validate the password.
 * @param {object} password - The password object.
 * @returns {string} - The validation message.
 */
export function passwordValidationMessage(password) {
    if (password.$error) {
        if (!password.minLength) {
            return `Password must have at least ${password.$params.minLength.min} letters.`;
        } else if (password.required && password.$model.length < 1) {
            return `Password is required`;
        } else {
            return "Invalid password";
        }
    }
    return "";
}

/** * Validate the email.
 * @param {object} email - The email object.
 * @returns {string} - The validation message.
 */
export function emailValidationMessage(email) {
    if (email.$error) {
        if (!email.required) {
            return "Enter a valid email";
        } else if (!email.email) {
            return "Email is invalid";
        } else if (!email.customValidator) {
            return "Email is already used.";
        }
    }
    return "";
}

/** * Validate if the birth date indicates the person is at least 18 years old.
 * @param {string} date - The birth date in a valid date format.
 * @returns {boolean} - True if the person is at least 18 years old, false otherwise.
 */
export function validateBirthDate(date) {
    let today = moment().utc(true);
    let birthday = moment(date).utc(true);
    let years = today.diff(birthday, "years");
    return years >= 18 ? true : false;
}

/** * Validate if the license date is in the future.
 * @param {string} date - The license date in a valid date format.
 * @returns {boolean} - True if the license date is in the future, false otherwise.
 */
export function validateLicenseDate(date) {
    let today = moment().utc(true);
    let licenseday = moment(date).utc(true);
    return moment(today).isBefore(licenseday, "days") ? true : false;
}